<template>
    <div style="overflow:hidden;">
        <div class="left">
            <div>
                Hi，
                <i v-text="$store.state.user.userInfo.personalName"></i>
            </div>
            <div v-show="$store.state.user.userInfo.passportType != 3">
                <i v-text="judgeVipText"></i>
            </div>
        </div>
        <div class="right">
            <img src="@/assets/img/icon/logo.png" alt="" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "usericon",
    data() {
        return {
            judgeVipText: ""
        };
    },
    computed: {
        ...mapState({
            judgeVip: state => state.user.userInfo.judgeVip,
            vipStatus: state => state.user.userInfo.vipStatus
        })
    },
    watch: {
        judgeVip() {
            if (this.vipStatus > 0) {
                switch (this.judgeVip) {
                    case 0:
                        this.judgeVipText = "免费版";
                        break;
                    case 1:
                        this.judgeVipText = "免费版";
                        break;
                    case 2:
                        this.judgeVipText = "VIP";
                        break;
                    case 3:
                        this.judgeVipText = "SVIP";
                        break;
                    default:
                        break;
                }
            } else {
                this.judgeVipText = "免费版";
            }
        }
    },
    mounted() {
        this.getVip(
            this.$store.state.user.userInfo.judgeVip,
            this.$store.state.user.userInfo.vipStatus
        );
    },
    methods: {
        getVip(val, status) {
            if (status > 0) {
                switch (val) {
                    case 0:
                        this.judgeVipText = "免费版";
                        break;
                    case 1:
                        this.judgeVipText = "免费版";
                        break;
                    case 2:
                        this.judgeVipText = "VIP";
                        break;
                    case 3:
                        this.judgeVipText = "SVIP";
                        break;
                    default:
                        break;
                }
            } else {
                this.judgeVipText = "免费版";
            }
        }
    }
};
</script>

<style lang="scss" scoped>
div {
    line-height: normal;
}
.left {
    float: left;
    margin: 10px 0;
    text-align: right;
    div {
        line-height: 20px;
    }
}
.right {
    float: left;
    margin: 9px 24px 8px 20px;
    img {
        width: 40px;
        height: 40px;
    }
}
</style>
